import moment from 'moment';

import {
  CustomerRequest,
  EventTrackingActionCreator,
  IBuyerRepairPreference,
  IDocumentChecklistItem,
  IListingOffer,
  IListingOfferBasic,
  RepairPreference,
} from '../../declarations';
import * as actionTypes from './actionTypes';

export function maybeFetchListingOffer(listingOfferId: string | number, token?: string) {
  return {
    payload: { listingOfferId: listingOfferId.toString(), token },
    type: actionTypes.MAYBE_FETCH_LISTING_OFFER,
  };
}

export function beginLoadingListingOffer() {
  return {
    type: actionTypes.BEGIN_LOADING_LISTING_OFFER,
  };
}

export function receiveListingOffer(listingOffer: IListingOffer) {
  return {
    payload: { listingOffer },
    type: actionTypes.RECEIVE_LISTING_OFFER,
  };
}

export function errorListingOffer(error: string) {
  return {
    error: true,
    payload: { error },
    type: actionTypes.ERROR_LISTING_OFFER,
  };
}

export function clearListingOffer() {
  return {
    type: actionTypes.CLEAR_LISTING_OFFER,
  };
}

export function maybeFetchListingOffers() {
  return {
    type: actionTypes.MAYBE_FETCH_LISTING_OFFERS,
  };
}

export function beginLoadingListingOffers() {
  return {
    type: actionTypes.BEGIN_LOADING_LISTING_OFFERS,
  };
}

export function receiveListingOffers(listingOffers: IListingOfferBasic[]) {
  return {
    payload: { listingOffers },
    type: actionTypes.RECEIVE_LISTING_OFFERS,
  };
}

export function errorListingOffers(error: string) {
  return {
    error: true,
    payload: { error },
    type: actionTypes.ERROR_LISTING_OFFERS,
  };
}

export function clearListingOffers() {
  return {
    type: actionTypes.CLEAR_LISTING_OFFERS,
  };
}

export function downloadChecklistDocument(documentId: number) {
  return {
    payload: { documentId },
    type: actionTypes.DOWNLOAD_CHECKLIST_DOCUMENT,
  };
}

export function uploadChecklistDocument(
  name: string,
  documentType: string,
  fileBase64DataUrl: string,
  requestId: number,
  checklistItemId?: number,
) {
  return {
    payload: { documentType, checklistItemId, fileBase64DataUrl, requestId, name },
    type: actionTypes.UPLOAD_CHECKLIST_DOCUMENT,
  };
}

export function beginUploadChecklistDocument(requestId: number) {
  return {
    payload: { requestId },
    type: actionTypes.BEGIN_UPLOAD_CHECKLIST_DOCUMENT,
  };
}

export function successUploadChecklistDocument(requestId: number) {
  return {
    payload: { requestId },
    type: actionTypes.SUCCESS_UPLOAD_CHECKLIST_DOCUMENT,
  };
}

export function errorUploadChecklistDocument(requestId: number, error: string) {
  return {
    error: true,
    payload: { requestId, error },
    type: actionTypes.SUCCESS_UPLOAD_CHECKLIST_DOCUMENT,
  };
}

export function removeChecklistDocument(documentId: number) {
  return {
    payload: { documentId },
    type: actionTypes.REMOVE_CHECKLIST_DOCUMENT,
  };
}

export function beginRemoveChecklistDocument(documentId: number) {
  return {
    payload: { documentId },
    type: actionTypes.BEGIN_REMOVE_CHECKLIST_DOCUMENT,
  };
}

export function successRemoveChecklistDocument(documentId: number) {
  return {
    payload: { documentId },
    type: actionTypes.SUCCESS_REMOVE_CHECKLIST_DOCUMENT,
  };
}

export function errorRemoveChecklistDocument(documentId: number, error: string) {
  return {
    error: true,
    payload: { documentId, error },
    type: actionTypes.SUCCESS_REMOVE_CHECKLIST_DOCUMENT,
  };
}

export function updateChecklistItem(checklistItem: IDocumentChecklistItem) {
  return {
    payload: { checklistItem },
    type: actionTypes.UPDATE_CHECKLIST_ITEM,
  };
}

export function submitChangeClosingDateRequest(newDate: moment.Moment, reason: string) {
  return {
    payload: { newDate, reason },
    type: actionTypes.SUBMIT_CHANGE_CLOSING_DATE_REQUEST,
  };
}

export function receiveCustomerRequest(customerRequest: CustomerRequest) {
  return {
    payload: { customerRequest },
    type: actionTypes.RECEIVE_CUSTOMER_REQUEST,
  };
}

export function requestGenerateSellerResponse() {
  return {
    payload: {},
    type: actionTypes.REQUEST_GENERATE_SELLER_RESPONSE,
  };
}

export function errorRequestGenerateSellerResponse(error: string) {
  return {
    error: true,
    payload: { error },
    type: actionTypes.ERROR_REQUEST_GENERATE_SELLER_RESPONSE,
  };
}

export function successRequestGenerateSellerResponse() {
  return {
    payload: {},
    type: actionTypes.SUCCESS_REQUEST_GENERATE_SELLER_RESPONSE,
  };
}

export const trackEvent: EventTrackingActionCreator<typeof actionTypes.TRACK_EVENT> = (
  category,
  action,
  label,
  extra,
) => {
  return {
    payload: { category, action, label, extra },
    type: actionTypes.TRACK_EVENT,
  };
};

export function submitBuyerRepairPreferences(
  notes: string | null,
  preferredSellerResponse: RepairPreference,
) {
  return {
    payload: {
      notes,
      preferredSellerResponse,
    },
    type: actionTypes.SUBMIT_BUYER_REPAIR_PREFERENCES,
  };
}

export function updateBuyerRepairPreferences(buyerRepairPreference: IBuyerRepairPreference) {
  return {
    payload: { buyerRepairPreference },
    type: actionTypes.UPDATE_BUYER_REPAIR_PREFERENCES,
  };
}

export function beginUpdateBuyerRepairPreferences() {
  return {
    payload: {},
    type: actionTypes.BEGIN_UPDATE_BUYER_REPAIR_PREFERENCES,
  };
}

export function successUpdateBuyerRepairPreferences() {
  return {
    payload: {},
    type: actionTypes.SUCCESS_UPDATE_BUYER_REPAIR_PREFERENCES,
  };
}

export function errorUpdateBuyerRepairPreference(error: string) {
  return {
    error: true,
    payload: { error },
    type: actionTypes.ERROR_UPDATE_BUYER_REPAIR_PREFERENCES,
  };
}

export function beginClaimListingOfferByToken() {
  return {
    payload: {},
    type: actionTypes.BEGIN_CLAIM_LISTING_OFFER_BY_TOKEN,
  };
}

export function successClaimListingOfferByToken() {
  return {
    payload: {},
    type: actionTypes.SUCCESS_CLAIM_LISTING_OFFER_BY_TOKEN,
  };
}

export function errorClaimListingOfferByToken(error: string) {
  return {
    error: true,
    payload: { error },
    type: actionTypes.ERROR_CLAIM_LISTING_OFFER_BY_TOKEN,
  };
}
